import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Loader from "./components/Loader";

// LAZY LOAD PAGES
const Home = lazy(() => import("./pages/Home"));
const Register = lazy(() => import("./pages/Register"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const MenuManager = lazy(() => import("./pages/MenuManager"));
const MenuCard = lazy(() => import("./pages/MenuCard"));
const RestaurantOrders = lazy(() => import("./pages/RestaurantOrders"));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/manage/:id" element={<MenuManager />} />
          <Route path="/menu/:id" element={<MenuCard />} />
          <Route path="/admin/orders/:id" element={<RestaurantOrders />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}